<template>
  <div id="map-box"></div>
</template>
<script src="//webapi.amap.com/ui/1.1/main.js?v=1.1.1"></script>
<script>
import AMap from "AMap";
export default {
  name: "DrawMap",
  props: {
    mapData: {
      type: Object,
      required: true,
    },
    carData: {
      type: Array,
      required: true,
    },
    centerLnglat: {
      type: Array,
      required: false,
    },
    alarmLnglat: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      map: null,
      scale: null,
      strokeColor: "#090086",
      vehicleMarker: [],
      districtExplorer: null,
      alarmMarker: [],
    };
  },
  created: function () {
    // this.drawMap()
    // this.addVehicleMarker()
  },
  watch: {
    mapData(val) {
      if (val) {
        this.$nextTick(() => {
          this.drawMap();
        });
      }
    },
    carData(val) {
      if (val) {
        this.$nextTick(() => {
          this.addVehicleMarker();
        });
      }
    },
    centerLnglat(val) {
      if (val) {
        this.$nextTick(() => {
          this.map.setCenter(this.centerLnglat);
          this.map.setZoom(16);
        });
      }
    },
    alarmLnglat(val) {
      let _this = this;
      if (val) {
        _this.$nextTick(() => {
          if (_this.alarmMarker) {
            _this.map.remove(_this.alarmMarker);
            _this.alarmMarker = [];
          }
          this.alarmMarker = new AMap.Marker({
            position: this.alarmLnglat,
            icon: require("@/assets/images/fence-alarm.png"),
            size: new AMap.Size(20, 30),
            map: this.map,
          });
          this.map.add(this.alarmMarker);
          this.map.setCenter(this.alarmLnglat);
          this.map.setZoom(16);
        });
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.map = new AMap.Map("map-box", {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 10,
        mapStyle: "amap://styles/fresh",
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
    },
    drawMap() {
      let _this = this;
      //圆形围栏
      if (_this.mapData.shapeType == 1) {
        _this.map.clearMap();
        let center = _this.mapData.center.split(",");
        let circle = new AMap.Circle({
          center: center,
          radius: _this.mapData.radius, //半径
          strokeColor: _this.strokeColor,
          strokeOpacity: 1,
          strokeWeight: 2,
          fillOpacity: 0.3,
          fillColor: _this.strokeColor,
        });
        circle.setMap(_this.map);
      }
      //多边形围栏
      else if (_this.mapData.shapeType == 2) {
        _this.map.clearMap();
        let path = _this.mapData.pointList;
        let polygon = new AMap.Polygon({
          path: path,
          strokeColor: _this.strokeColor,
          strokeWeight: 2,
          strokeOpacity: 1,
          fillOpacity: 0.3,
          fillColor: _this.strokeColor,
        });
        _this.map.add(polygon);
      }
      //区域围栏
      else if (_this.mapData.shapeType == 4) {
        _this.map.clearMap();
        AMapUI.loadUI(["geo/DistrictExplorer"], function (DistrictExplorer) {
          //创建一个实例
          _this.districtExplorer = new DistrictExplorer({
            map: _this.map,
          });
          let adcode = _this.mapData.adcode;
          _this.districtExplorer.loadAreaNode(
            adcode,
            function (error, areaNode) {
              //更新地图视野
              _this.map.setBounds(areaNode.getBounds(), null, null, true);
              //清除已有的绘制内容
              _this.districtExplorer.clearFeaturePolygons();
              //绘制区域
              _this.districtExplorer.renderParentFeature(areaNode, {
                cursor: "default",
                bubble: true,
                strokeColor: _this.strokeColor, //线颜色
                strokeOpacity: 1, //线透明度
                strokeWeight: 2, //线宽
                fillColor: _this.strokeColor, //填充色
                fillOpacity: 0.3, //填充透明度
              });
            }
          );
        });
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this;
      let data = this.carData;
      if (_this.vehicleMarker.length) {
        _this.map.remove(_this.vehicleMarker);
        _this.vehicleMarker = [];
      }
      for (var i = 0; i < data.length; i++) {
        let marker = "";
        marker = new AMap.Marker({
          position: data[i].lnglat,
          icon: require("@/assets/images/car-online.png"),
          size: new AMap.Size(20, 30),
          map: _this.map,
        });
        marker.setLabel({
          offset: new AMap.Pixel(-18, 0), //设置文本标注偏移量
          content: "<div class='info'>" + data[i].plateNum + "</div>", //设置文本标注内容
          direction: "right", //设置文本标注方位
        });
        _this.vehicleMarker.push(marker);
        // _this.vehicleMarker.emit("click", { target: _this.vehicleMarker })
      }
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.add(_this.vehicleMarker);
        _this.map.setZoom(10);
        //依据第一个坐标位置设置中心点
        //_this.map.setCenter(data[0].lnglat)
        //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#map-box /deep/ {
  width: 100%;
  height: 100%;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  .amap-marker-label {
    width: 100px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    padding: 0;
    background: #072730;
    border: 1px solid #ffffff;
    border-radius: 14px;
    font-size: 14px;
    color: #fff;
    z-index: -1;
  }
}
::v-deep .amap-scalecontrol {
  left: auto !important;
  right: 2px;
}
</style>
